import { useSelector } from 'react-redux'
import {
  connectionStatusView,
  isMultiTabView,
  loadedView,
} from '$comp/main/root.reducer'
import { t } from '$i18n'

export function useIsAppLoaded() {
  return useSelector(loadedView)
}

export function useIsMultiTab() {
  const isMultiTab = useSelector(isMultiTabView)
  return Boolean(isMultiTab)
}

export function useDisplayedConnectionStatus() {
  const status = useSelector(connectionStatusView)

  switch (status) {
    case 'connecting':
    case 'authenticating':
      return t('connectionStatus.connecting')
    case 'updating':
      return t('connectionStatus.updating')
    default:
      return null
  }
}
